export const ROLE = {
  finnix_admin : "FINNIX_ADMIN",
  broker_admin : "BROKER_ADMIN",
  modeler : "MODELER"
}